import { Component, OnInit, Renderer2 } from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Subscription } from "rxjs";

@Component({
    selector: "app-xapi",
    templateUrl: "./xapi.component.html",
    styleUrls: ["./xapi.component.scss"],
    standalone: false
})
export class XapiComponent implements OnInit {
  qpListener : Subscription ;

  errorMessage : String = '';

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2,
  ) {}


  // https://beta.hemisphereapp.io/xapi?activationCode=SDWUIC&course_id=1&user_id=1&username=jan&course_code=courseCode&actor={"mbox":["mailto:jan.pittner212312%2Bdocebo@example.com"],"name":["Jan+Pittner"]}&hash=846c714462105ef5f195a2486dfd06c4713155c022ff6f75abf8b43fd1d8d947

  // https://general.hemisphereapp.io/xapi?activationCode=SDWUIC&endpoint=https:%2F%2Fburgessalmon.docebosaas.com%2Ftcapi%2F&auth=Basic%20L1JTMTI6JDJ5JDEzJC8yQUc4M0NpWjNMa21ZbHpLMWZNWGV1S05wU3ZlZmdwSlNnV2x5OUtrbG1iblJWb0JnaHBP&actor=%7B%22mbox%22:%5B%22mailto:Richard.Schollick@burges-salmon.com%22%5D,%22name%22:%5B%22Richard%20Schollick%22%5D%7D&registration=c16ae713-49ca-4dcb-8bb8-53c90eeeb44e&activity_id=http:%2F%2Fdocebo.com%2Ftincan%2Fcustom%2Factivity%2F4500bf8d96c6253356609b12242d8a97707e4331de74f75b8bf228f30531b8e6&Accept-Language=en-gb&course_id=4336&content_token=c16ae713-49ca-4dcb-8bb8-53c90eeeb44e&session_context=lms&xapi_auth_code=63dece2e2a6381e65c0721ec76e4c6bd48ec7701&course_code=&username=RS12&user_id=13035&hash=2759a9c98cfa2d4d98b9825c6dac369b2ace603cd182bece7fc41cd037c9aee6

  // course_code,course_id,username,user_id,salt

  ngOnInit() {
    this.qpListener = this.route.queryParams.subscribe(
      async (params: Params) => {
        const userId = Array.isArray(params.user_id) ? params.user_id[0] : params.user_id
        let courseId = params.course_id

        // check if course id has been sent twice as a query param, which would make it an array.
        if( Array.isArray(courseId) ){
          courseId = courseId[0]
        }

        const courseCode = params.course_code
        const activationCode = params.activationCode
        const username = params.username
        const hash = params.hash
        if( !params.actor ){
          this.errorMessage = "Invalid request."
          return
        }
        const decodedActor = decodeURIComponent(params.actor)
        const actor = JSON.parse(decodedActor)

        const email = actor.mbox[0].split("mailto:")[1]

        this.renderer.addClass(document.body, 'loading');

        try{
             const signin = await this.authService.xapiSignin(activationCode, email, userId, courseId, courseCode, username, hash)

             console.log("got signin response: " , signin)
             this.renderer.removeClass(document.body, 'loading');

            if( signin.success ){
              this.router.navigate(['/start']);
            }else{
              this.errorMessage = signin.message ? signin.message : signin
            }

        }
        catch( e ){
          const message = e.message ? e.message : e._body ? e._body : e.error ? e.error : e
          this.renderer.removeClass(document.body, 'loading');
          this.errorMessage = "Something went wrong: " + message
        }

      }
    );
  }

  ngOnDestroy(): void {
    if (this.qpListener) {
      this.qpListener.unsubscribe();
    }
  }
}
